import React from 'react';
import { Box } from '@mui/material';
import { useBranding } from '../context/BrandingContext';

// Comentários em português; código em inglês
// Componente reutilizável para exibir logos por slot/variant com fallback opcional

const BrandLogo = ({ slot, variant = 'light', alt = 'Logo', sx = {}, fallbackSrc }) => {
	const { getLogo, sizing } = useBranding();
	const src = getLogo(slot, variant);

	// Não renderiza imagem quando não houver URL definida
	if (!src) return null;

	// Aplica tamanho personalizado, se configurado
	const slotSizing = sizing?.[slot]?.[variant] || sizing?.[slot]?.main;
	const widthPx = slotSizing?.width ? `${slotSizing.width}px` : undefined;
	const heightPx = slotSizing?.height ? `${slotSizing.height}px` : undefined;

	return (
		<Box 
			component="img" 
			src={src} 
			alt={alt} 
			sx={{ display: 'block', width: widthPx, height: heightPx, objectFit: 'contain', ...sx }} 
		/>
	);
};

export default BrandLogo;
